import { StoryblokImage } from '@cinch-nx/data-storyblok'
import { FinanceOfferCard } from '@cinch-nx/ui-finance'

interface FinanceOfferCardBlockProps {
  image: StoryblokImage
  banner: string
  title: string
  offerDetail1: string
  offerDetail2: string
  offerDetail3: string
  offerDetail4: string
  footerText: string
}

export const FinanceOfferCardBlock = ({
  image,
  banner,
  title,
  offerDetail1,
  offerDetail2,
  offerDetail3,
  offerDetail4,
  footerText,
}: FinanceOfferCardBlockProps) => (
  <FinanceOfferCard
    image={{ src: image.filename, alt: image.alt ?? '' }}
    banner={banner}
    title={title}
    offerDetails={[offerDetail1, offerDetail2, offerDetail3, offerDetail4]}
    footerText={footerText}
  />
)
